export default "__VITE_ASSET__DHEFeovl__"